// Package imports:
import React from 'react';
// Component imports:
import FooterComp from '../../components/Footer/Footer';

interface IProps {
    showPhoneNumber?: boolean;
}

const Footer: React.FC<IProps> = ({ showPhoneNumber }) => {
    return (
        <FooterComp showPhoneNumber={showPhoneNumber} />
    );
}

export default Footer;